// A one-time suggestion on Home to turn on notifications on this device: class reminders for students
// and staff, alerts (absences and missed compulsory tests) for parents.
import { useState } from 'preact/hooks';
import { Icon } from './icons.js';
import { Button, useToast } from './components.jsx';
import { enableNotifications, permission, pushSupport } from '../push.js';

const PROMPT_KEY = 'vv-reminder-prompt';

export function ReminderPrompt({ title = 'Get a reminder before each class', text = 'A notification 30 minutes before class, and when the academy posts an update.', label = 'Class reminders', done = 'Reminders are on for this device' }) {
  const toast = useToast();
  const [show, setShow] = useState(() => {
    try { return pushSupport() === 'ok' && permission() === 'default' && localStorage.getItem(PROMPT_KEY) !== 'no'; } catch (e) { return false; }
  });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  if (!show) return null;
  const hide = () => { try { localStorage.setItem(PROMPT_KEY, 'no'); } catch (e) { /* ignore */ } setShow(false); };
  const turnOn = async () => {
    setBusy(true); setErr(null);
    try { await enableNotifications(); toast(done); hide(); } catch (e) { setErr(e.message); }
    setBusy(false);
  };
  return (
    <div class="prompt" role="region" aria-label={label}>
      <span class="prompt-icon"><Icon name="bell" /></span>
      <div class="prompt-text">
        <strong>{title}</strong>
        <span>{text}</span>
        {err ? <span class="field-error" role="alert">{err}</span> : null}
      </div>
      <div class="prompt-actions">
        <Button variant="gold" size="sm" busy={busy} onClick={turnOn}>Turn on</Button>
        <Button variant="ghost" size="sm" onClick={hide}>Not now</Button>
      </div>
    </div>
  );
}
